import { Box } from '@mui/material'
// eslint-disable-next-line no-restricted-imports
import { Outlet } from 'react-router'
import React, { Suspense } from 'react'
import { Main } from '../styles'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { drawerOpenAtom } from '../state'
import { DemoUserBanner } from './DemoUserBanner'

export function AppContent() {
  const open = !useAtomValue(drawerOpenAtom)
  return (
    <Suspense fallback={<Box>Loading...</Box>}>
      <Main open={open}>
        <div style={{ height: 40 }} />
        <DemoUserBanner />
        <Outlet />
      </Main>
    </Suspense>
  )
}
